
angular.module('bmsApp.directives')
	.directive('complaints', [
		'$modal',
		'$ngBootbox',
		'notify',
		'ComplaintSvc',
		'ConfigService', function (
			$modal,
			$ngBootbox,
			notify,
			ComplaintSvc,
			ConfigService) {
			return {
				restrict: 'E',
				scope: {
					objectType: '=',
					objectId: '=',
					dropzone: '=',
					complaintapi: '='
				},
				replace: true,
				templateUrl: 'ng/complaints/templates/ComplaintList.html',
				link: function (scope, element, attrs) {
					scope.complaintapi = {
						showComplaints: function () {
							//scope.$broadcast('showNotes');
						},
						showForm: function () {
							scope.showComplaintForm();
						},
					};

					scope.$watchGroup(['objectType', 'objectId'], function(newValues, oldValues, scope) {
						scope.$broadcast('showComplaints');
					});
				},
				controller: function ($scope, $rootScope) {
					$scope.config = ConfigService.config;
					$scope.isSM = $rootScope.isSM;
					$scope.isMM = $rootScope.isMM;

					$scope.showComplaintForm = function (complaint) {
						var modalInstance = $modal.open({
							animation: true,
							templateUrl: 'ng/complaints/templates/ComplaintForm.html',
							controller: 'ComplaintFormCtrl',
							size: 'lg',
							scope: $scope,
							backdrop: 'static', // disable click-outside closing modal
							resolve: {
								complaint: function () {
									var newComplaint = {};
									if (complaint) {
										angular.extend(newComplaint, angular.copy(complaint));
									}
									angular.extend(newComplaint, {
										complaintable_type: $scope.objectType,
										complaintable_id: $scope.objectId
									});
									return newComplaint;
								},
								viewOnly: function (){
									return false;
								}
							}
						});

						modalInstance.result.then(function (result) {
							if (result.success) {
								switch (result.action) {
									case 'create':
										message = 'Complaint added successfully';
										break;
									case 'update':
										message = 'Complaint updated successfully';
										break;
									default:
										message = 'Success';
										break;
								}
								notify({
									message: message
								});
								$scope.$broadcast('complaintUpdated');
							}
							else {
								notify({
									message: result.error,
									classes: 'error'
								});
							}
						}, function () {
							// closed
						});

					};

					$scope.showComplaintNoteForm = function (complaintNote, complaint) {
						var modalInstance = $modal.open({
							animation: true,
							templateUrl: 'ng/complaints/templates/ComplaintNoteForm.html',
							controller: 'ComplaintNoteFormCtrl',
							size: 'lg',
							scope: $scope,
							backdrop: 'static', // disable click-outside closing modal
							resolve: {
								complaintNote: function () {
									var newComplaintNote = {};
									if (complaintNote) {
										angular.extend(newComplaintNote, angular.copy(complaintNote));
									}
									angular.extend(newComplaintNote, {
										complaint: complaint,
									});
									console.log(newComplaintNote);
									return newComplaintNote;
								}
							}
						});

						modalInstance.result.then(function (result) {
							if (result.success) {
								switch (result.action) {
									case 'create':
										message = 'Comment added successfully';
										break;
									case 'update':
										message = 'Comment updated successfully';
										break;
									default:
										message = 'Success';
										break;
								}
								notify({
									message: message
								});
								$scope.$broadcast('complaintUpdated');
							}
							else {
								notify({
									message: result.error,
									classes: 'error'
								});
							}
						}, function () {
							// closed
						});

					};

					$scope.complaintDelete = function (complaint) {
						$ngBootbox.confirm('Delete complaint "' + complaint.subject + '"?')
							.then(function () {
								ComplaintSvc.delete(complaint)
									.then(function (response) {
										notify({
											message: 'Complaint deleted successfully'
										});
										$scope.$broadcast('complaintUpdated');
									}, function (error) {
										notify({
											message: 'Complaint deleted successfully',
											classes: 'error'
										});
										$log.error(error);
									});
							});
					};
				}
			};
		}]);
